import React from 'react';
import { RideTextField } from '@rimac-seguros/ride-system-components';
import Regex from '@/utils/regex';
import './styles.scss';

const FormContact = ({
    register,
    errors
}) => {

    const handleInputPhone = (event) => {
        const el = event.target;
        el.value = el.value.replace(/[^0-9]/g, '');
    };

    return (
        <div id="form-contact" className='form-contact'>
            <h3>Datos personales</h3>
            <div className='form-contact_content'>
                <div className='form-contact_input'>
                    <RideTextField
                        {...register('phone', { required: true, minLength: 9, pattern: Regex.phone })}
                        aria-required
                        label='Celular'
                        maxLength={9}
                        size='large'                    
                        error={!!errors?.phone}
                        errorMessage={errors?.phone?.type === 'required' ? 'Este campo es obligatorio' : 'Formato de número de celular incorrecto'}
                        onInput={handleInputPhone}
                    />
                </div>
                <div className='form-contact_input'>
                    <RideTextField
                        {...register('email', { required: true, pattern: Regex.email })}
                        aria-required
                        label="Correo electrónico"
                        size="large"
                        error={!!errors?.email}
                        errorMessage={errors?.email?.type === 'required' ? 'Este campo es obligatorio' : 'Ingresa un correo válido'}
                    />
                </div>
            </div>
            <span className="mt-ride-gl-spacing-medium lg:mt-ride-gl-spacing-xlarge ride-sys-text-label-small-regular text-ride-sys-color-text-extreme">
                Al continuar, aceptas que la póliza del seguro y las comunicaciones 
                relacionadas se envíen al correo electrónico ingresado.
            </span>
        </div>
    )
};

export default FormContact;